import { Controller } from '@hotwired/stimulus';

const ANIMATION_DELAY = 150;
const NOTIFICATION_DURATION = 10000;
export default class FlashMessagesController extends Controller {
  static targets = ['alert'];

  connect() {
    this.initAlerts();
  }

  initAlerts() {
    this.alertTargets.forEach((alert) => {
      setTimeout(() => {
        this.removeElement(alert);
      }, NOTIFICATION_DURATION);
    });
  }

  removeAlert(event) {
    const alert = event.currentTarget;
    this.removeElement(alert);
  }

  removeElement(element) {
    element.classList.remove('show');
    setTimeout(() => element.remove(), ANIMATION_DELAY);
  }
}
